import React from 'react';

import { easasAlert } from 'components/fragments/easas-global-fragment/EasasGlobalAlerts';
import { MdmDevice, useGetDeviceQuery, useUpdateDeviceMutation } from 'gql/generated/types';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useNavigate, useParams } from 'react-router-dom';
import DeviceForm from '../components/DeviceForm';
import ErrorPage from './ErrorPage';

const EditDeviceForm = () => {
  const params = useParams()
  const navigate = useNavigate()
  const { data, error, loading } = useGetDeviceQuery({ variables: { id: params.deviceId! } });
  const [mutateFunction] = useUpdateDeviceMutation({
    onCompleted: () => {
      easasAlert({
        severity: "success",
        summary: "Success",
        detail: "Device updated successfully",
        life: 3000,
      });
      navigate("/devices");
    },
    onError: err => {
      easasAlert({ severity: "error", summary: "Error", detail: err.message, life: 3000 });
    },
    refetchQueries: ["GetAllDevicesByProject", "GetDevice"],
  });
  
  if (error) {
    return <ErrorPage msg={`Device not found by id: ${params.deviceId}`} />;
  }

  if (loading) return <ProgressSpinner className='mt-3 w-full' />

  const handleUpdate = (device: MdmDevice) => {
    const { project, mdmObject, createdAt, modifiedAt, ...restDevice } = device
    mutateFunction({ variables: { device: {...restDevice},objectId: mdmObject?.id! } })

  }
  return (
    <DeviceForm device={data?.mdmDeviceById! as MdmDevice} onSubmit={handleUpdate}/>
  )
}

export default EditDeviceForm